<div class="background-image-container mt-ncs">
  <div class="container">
    <div class="home-news-content py-4 px-2 py-sm-5 px-sm-0 mt-0 mb-4">
      <div class="d-flex flex-wrap">
        <div>
          <h1 class="display-3">WRCO</h1>
          <p class="display-4">Web Representação do Conhecimento e Ontologias</p>
          <p class="lead">É com grande satisfação que o recebemos repositório digital do grupo de pesquisa Web, Representação do Conhecimento e Ontologias - WRCO. Aqui, você encontrará diversos objetos digitais inseridos em nossas comunidades e coleções, todos voltados para o ensino e a pesquisa no contexto da Ciência da Informação.</p>
          <p>Nosso repositório é um espaço dedicado à preservação e ao compartilhamento de conhecimento, com o objetivo de apoiar e promover a disseminação de estudos e práticas relacionadas à representação do conhecimento, ontologias, gestão de dados de pesquisa e áreas afins. Através das contribuições de pesquisadores e acadêmicos, buscamos fornecer recursos que possam enriquecer a sua experiência de aprendizado e pesquisa.</p>

          <p>Explore, utilize e compartilhe o conhecimento aqui disponível. Estamos comprometidos com a expansão do acesso à informação e com o fortalecimento da nossa comunidade científica.</p>

          <p>Seja bem-vindo(a) e aproveite ao máximo os recursos oferecidos pelo nosso repositório.</p>          

          <p>Apoiado através da Chamada FAPESQ-PB/CNPq nº 77/2022</p>

        </div>
      </div>
    </div>
  </div>
  <picture class="background-image">
    <source type="image/webp" srcset="assets/dspace/images/banner.webp 2000w, assets/dspace/images/banner-half.webp 1200w, assets/dspace/images/banner-tall.webp 768w">
    <source type="image/jpg" srcset="assets/dspace/images/banner.jpg 2000w, assets/dspace/images/banner-half.jpg 1200w, assets/dspace/images/banner-tall.jpg 768w">
    <img alt="" [src]="'assets/dspace/images/banner.jpg'"/><!-- without the []="''" Firefox downloads both the fallback and the resolved image -->
  </picture>
  <!-- <small class="credits">Photo by <a href="https://www.pexels.com/@inspiredimages">&#64;inspiredimages</a></small> -->
</div>
